export const CONSENT_STORAGE_KEY = 'ogkeys.consent.v1';
/** Dispatched on `window` with the new consent as `detail` whenever it is saved. */
export const CONSENT_CHANGED_EVENT = 'ogkeys:consent-changed';

export interface CookieConsent {
  essential: true;
  analytics: boolean;
  marketing: boolean;
  decidedAt: string | null;
}

export function defaultConsent(): CookieConsent {
  return { essential: true, analytics: false, marketing: false, decidedAt: null };
}

export function loadConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      essential: true,
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
      decidedAt: typeof parsed.decidedAt === 'string' ? parsed.decidedAt : null,
    };
  } catch {
    return null;
  }
}

export function saveConsent(c: CookieConsent) {
  c.decidedAt = c.decidedAt ?? new Date().toISOString();
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(c));
  } catch {
    // private mode etc — silently ignore
  }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: c }));
}
